import { Theme } from '@mui/material';

export const getRubricCellStyles = (theme: Theme, isSelected: boolean, isReadOnly: boolean) => {
  const baseStyles = {
    border: `1px solid ${theme.palette.gray.mediumLight}`,
    backgroundColor: 'transparent',
  };

  if (isReadOnly) {
    return {
      ...baseStyles,
      ...(isSelected && {
        border: `2px solid ${theme.palette.gray.mediumLight}`,
        backgroundColor: theme.palette.gray.lighter,
      }),
      pointerEvents: 'none',
    };
  }

  return {
    ...baseStyles,
    ...(isSelected && {
      border: `2px solid ${theme.palette.success.main}`,
      backgroundColor: theme.palette.primary.fill,
    }),
  };
};
